var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramHelp40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.31373568,6.53243443 C2.98690099,6.53243443 5.15423693,8.69977037 5.15423693,11.3729357 L11.6082386,11.3729357 C11.6082386,5.13514598 6.55152998,0.078432768 0.31373568,0.078432768 L0.31373568,6.53243443 L0.31373568,6.53243443 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53243443,11.3729357 C6.53243443,8.69977037 8.69977037,6.53243443 11.3729357,6.53243443 L11.3729357,0.078432768 C5.13514598,0.078432768 0.0784341504,5.13514598 0.0784341504,11.3729357 L6.53243443,11.3729357 L6.53243443,11.3729357 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3729357,5.15423693 C8.69977037,5.15423693 6.53243443,2.98690099 6.53243443,0.31373568 L0.0784341504,0.31373568 C0.0784341504,6.55152998 5.13514598,11.6082381 11.3729357,11.6082381 L11.3729357,5.15423693 L11.3729357,5.15423693 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15423693,0.31373568 C5.15423693,2.98690099 2.98690099,5.15423693 0.31373568,5.15423693 L0.31373568,11.6082381 C6.55152998,11.6082381 11.6082386,6.55152998 11.6082386,0.31373568 L5.15423693,0.31373568 L5.15423693,0.31373568 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(8.500000, 8.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(11.059200, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFCC00",
    mask: "url(#mask-2)",
    points: "-1.99026432 -2.22556723 13.9122386 -2.22556723 13.9122386 13.6769357 -1.99026432 13.6769357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.3729357,6.53243443 C14.0461024,6.53243443 16.2134369,8.69977037 16.2134369,11.3729357 L22.6674386,11.3729357 C22.6674386,5.13514138 17.61073,0.078432768 11.3729357,0.078432768 L11.3729357,6.53243443 L11.3729357,6.53243443 Z",
    id: "Stroke-4",
    stroke: "#4F4D4C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "-2.22556585 -2.22556723 13.6769357 -2.22556723 13.6769357 13.6769357 -2.22556585 13.6769357"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.53243581,11.3729357 C6.53243581,8.69977037 8.69977175,6.53243443 11.3729371,6.53243443 L11.3729371,0.078432768 C5.13514276,0.078432768 0.0784341504,5.13514138 0.0784341504,11.3729357 L6.53243581,11.3729357 L6.53243581,11.3729357 Z",
    id: "Stroke-8",
    stroke: "#4F4D4C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 11.059200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFCC00",
    mask: "url(#mask-6)",
    points: "-2.22556585 -1.99026432 13.6769357 -1.99026432 13.6769357 13.9122381 -2.22556585 13.9122381"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.3729371,16.2134369 C8.69977175,16.2134369 6.53243581,14.0461024 6.53243581,11.3729357 L0.0784341504,11.3729357 C0.0784341504,17.61073 5.13514276,22.6674386 11.3729371,22.6674386 L11.3729371,16.2134369 L11.3729371,16.2134369 Z",
    id: "Stroke-12",
    stroke: "#4F4D4C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(11.059200, 11.059200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FFFFFF",
    mask: "url(#mask-8)",
    points: "-1.99026432 -1.99026432 13.9122386 -1.99026432 13.9122386 13.9122381 -1.99026432 13.9122381"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.2134369,11.3729357 C16.2134369,14.0461024 14.0461024,16.2134369 11.3729357,16.2134369 L11.3729357,22.6674386 C17.61073,22.6674386 22.6674386,17.61073 22.6674386,11.3729357 L16.2134369,11.3729357 L16.2134369,11.3729357 Z",
    id: "Stroke-16",
    stroke: "#4F4D4C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramHelp40);
export default __webpack_public_path__ + "static/media/pictogramHelp40.e9e74c8ca8659aecc656ec3cda752b4a.svg";
export { ForwardRef as ReactComponent };